import { memo } from 'react';

import { type SortDirection } from '@air/api/types';

import { SortMenu } from '~/components/SortButtons/SortMenu';
import { SORT_BUTTON } from '~/constants/testIDs';

export type ViewSortingMenuComponentProps = {
  availableSortOptions: readonly string[];
  currentlySortedBy: string;
  sortDirection: SortDirection;
  dataTestId?: string;
  onChange: (sortingFieldName: string, direction: SortDirection) => void;
  showDirectionInMenu?: boolean;
  compact?: boolean;
  supportsDirection?: (fieldName: string) => boolean;
};

export const ViewSortingMenuComponent = memo(
  ({
    currentlySortedBy,
    onChange,
    sortDirection,
    availableSortOptions,
    showDirectionInMenu,
    compact,
    supportsDirection,
  }: ViewSortingMenuComponentProps) => {
    return (
      <SortMenu
        data-testid={SORT_BUTTON}
        currentSortBy={currentlySortedBy}
        sortOptions={availableSortOptions}
        onSortChange={onChange}
        direction={sortDirection}
        showDirectionInMenu={showDirectionInMenu}
        compact={compact}
        supportsDirection={supportsDirection}
      />
    );
  },
);

ViewSortingMenuComponent.displayName = 'ViewSortingMenuComponent';
